<template>
  <q-layout view="lHh Lpr lFf" class="auth-layout">
    <q-page-container>
      <q-page class="flex flex-center no-scroll">
        <div class="login-box animate-fade-in">

          <!-- ЛОГО -->
          <div class="text-center q-mb-md">
            <img :src="require('@/assets/logo.png')" alt="Лого" class="logo" />
            <h6 class="text-mint text-bold q-mt-md"></h6>
            <div class="text-caption text-grey-7 q-mt-xs">
              
            </div>
          </div>

          <!-- КОПЧИЊА -->
          <div class="q-gutter-sm q-mt-md">

            <div class="text-center">
               <q-btn
                label="Најава клиент"
                class="btn-outline"
                outline
                rounded
                no-caps
                @click="$router.push('/najava-klient')"
              />
            </div>

            <div class="text-center">
              <q-btn
                label="Најава Вработен"
                class="btn-outline"
                outline
                rounded
                no-caps
                @click="$router.push('/najava-vraboten')"
              />
            </div>

          </div>

        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  name: "NajavaIzbor",

  mounted() {
    const tip = this.$route.query.tip;

    // Ако апликацијата е отворена преку WEB страната
    // и во линкот има ?tip=klient, тогаш оди на клиентска најава
    if (tip === "klient") {
      this.$router.replace("/najava-klient");
      return;
    }

    // Ако апликацијата е отворена директно без параметар,
    // тогаш default е најава за вработен
    this.$router.replace("/najava-vraboten");
  },
};
</script>

<style scoped>
/*  Глобална позадина без скрол  */
.auth-layout {
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(180deg, #f2f7f7 0%, #e8f0ef 100%);
}

/*  q-page fullscreen  */
.no-scroll {
  height: 100vh;
  overflow: hidden;
}

/*  Централна кутија  */
.login-box {
  width: 360px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s ease;
}
.login-box:hover {
  box-shadow: 0 10px 28px rgba(14, 107, 95, 0.22);
  transform: translateY(-2px);
}

/*  Лого */
.logo {
  width: 180px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(14, 107, 95, 0.25));
}

/*  Главно копче (исто како кај login) */
.btn-login {
  background-color: #0e6b5f !important;
  color: white !important;
  font-weight: 600;
  font-size: 15px;
  padding: 10px 0;
  width: 80%;
  transition: all 0.25s ease;
}
.btn-login:hover {
  background-color: #2d8c7f !important; /* посветло mint */
  box-shadow: 0 6px 14px rgba(14, 107, 95, 0.25);
}

/*  Второ копче (outline) */
.btn-outline {
  width: 80%;
  font-weight: 600;
  font-size: 15px;
  padding: 10px 0;
  border-color: rgba(14, 107, 95, 0.45) !important;
  color: #0e6b5f !important;
  transition: all 0.25s ease;
}
.btn-outline:hover {
  border-color: rgba(14, 107, 95, 0.85) !important;
  box-shadow: 0 4px 12px rgba(14, 107, 95, 0.12);
}

/*  Анимација при појава */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(25px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fadeIn 0.8s ease-out;
}

/*  Responsive  */
@media (max-width: 600px) {
  .login-box {
    width: 90%;
    padding: 28px 22px;
  }
  .logo {
    width: 140px;
  }
  .btn-login,
  .btn-outline {
    width: 100%;
  }
}

.text-mint {
  color: #0e6b5f !important;
}
</style>